import React from 'react';
import { FormControlLabel, Checkbox } from '@mui/material';

export default function CustomStartCommandCheckbox({ value, onChange, edit }) {
  const handleChange = (event) => {
    onChange(event.target.checked);
  };

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={value}
          onChange={handleChange}
          disabled={edit}
          name='custom_start_command'
        />
      }
      label='Manually Specify Server Command'
    />
  );
}

